import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/danielwong/facility-calcom/cal2/apps/web/modules/apps/categories/categories-view.tsx");
